/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';

// Styles
import useStyles from './lineSkeleton.styles';

interface LineSkeletonInterface {
  generateCount?: number;
  height?: number;
}

type Props = LineSkeletonInterface;

const LineSkeleton: React.FC<Props> = ({ generateCount = 1, height }) => {
  const classes = useStyles();

  return (
    <Grid container alignItems='center'>
      {Array.from({ length: generateCount }).map((s: any, i) => (
        <Skeleton
          key={`${s}-${i}`}
          style={{ height }}
          variant='text'
          className={classes.skeleton}
        />
      ))}
    </Grid>
  );
};

export default LineSkeleton;
export { LineSkeleton };
